import { useState } from 'react'

import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

import WhatBox from './level2/WhatBox'
import TechSpecs from './level2/TechSpecs'
import Service from './level2/Service'
import Warranty from './level2/Warranty'

import { Typography } from '@evocolabs/orkaui'

const data = [`What's in the Box`, 'Tech Specs', 'Ongoing Service', 'Warranty']

const ProductInfo = function ({ info = data } = props) {
  const [showLevel2, setShowLevel2] = useState('')
  const clickHandler = function (item) {
    setShowLevel2(item)
  }
  return (
    <List>
      {info.map((item, i) => (
        <ListItem
          id={`productbuy_${item
            ?.replace(/[\s]/g, '-')
            ?.replace(/[\'\"]/g, '')
            ?.toLowerCase()}`}
          disablePadding
          divider
          key={i}
          onClick={() => clickHandler(item)}
        >
          <ListItemButton
            disableRipple
            component="a"
            sx={{
              justifyContent: 'space-between',
              paddingLeft: 0,
              paddingRight: 0,
              height: 80
            }}
          >
            <Typography variant="h4" lineHeight="2">
              {item}
            </Typography>
            <ArrowForwardIosIcon />
          </ListItemButton>
        </ListItem>
      ))}
      <WhatBox
        open={data[0] === showLevel2}
        onClose={() => setShowLevel2('')}
      />
      <TechSpecs
        open={data[1] === showLevel2}
        onClose={() => setShowLevel2('')}
      />
      <Service
        open={data[2] === showLevel2}
        onClose={() => setShowLevel2('')}
      />
      <Warranty
        open={data[3] === showLevel2}
        onClose={() => setShowLevel2('')}
      />
    </List>
  )
}

export default ProductInfo
